module.exports = __webpack_public_path__ + "img/Flunder_2.6b65dcb2.jpg";